window.addEventListener('load', () => {
  const salonId = new URLSearchParams(window.location.search).get("salon_id");
  if (salonId) {
    document.cookie = `salon_id=${salonId}; path=/; Secure; SameSite=None`;
  }
});

window.addEventListener('load', () => {
  const salonId = new URLSearchParams(window.location.search).get("salon_id") || document.cookie.split("; ").find(row => row.startsWith('salon_id'))?.split("=")[1];

  // 文字種は問わず、10文字以上かどうか
  const isValidSalonId = typeof salonId === 'string' && salonId.length >= 10;

  if (isValidSalonId) {
    document.cookie = `salon_id=${encodeURIComponent(salonId)}; path=/; Secure; SameSite=None`;
  } else {
    // 条件に満たさない場合は cookie 削除
    document.cookie = "salon_id=; path=/; max-age=0; Secure; SameSite=None";
  }
});